import {JSEncrypt} from 'jsencrypt'
/* 加密工具类 */
var publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiSYGKCM8S6AGAyMAG7yyBfeVH5jz+TOlo3Ia5+7qu003ychNJnCH14VeTWt0edUCDl3dtejglB6mb9GR428Xn2bR+d0iawd7mw3sq8Gv2gKha/vWlSlFXvQKJBImMb6A70kYfgKpBV/j1DSEJfNFx4GEXs+D/5gk5ire8BIE4w33wbctqawZxqYMDfVJ8q0ces9JEPDIKoN80xpSp9wWUtZFvLVXZEABGXwfnZ+1g2ullO5Z+E8SQSvl6O78zqVphB0e3rqYL90QiHFN4ghhr8DpEhbDqY2zJ7JWnclO9JVJu/rUKmpZHEd+pUC6QbOSJ3+/PavSEb2enacXyHqBNQIDAQAB';
let privateKey = '' // 私钥

// 加密方法
let RSAencrypt = (pas) => {
  // 实例化jsEncrypt对象
  let jse = new JSEncrypt()
  // 设置公钥
  jse.setPublicKey(publicKey)
  // console.log('加密：'+jse.encrypt(pas))
  return jse.encrypt(pas)

}
// 解密方法
let RSAdencrypt = (pas) => {
  // 实例化jsEncrypt对象
  let jse = new JSEncrypt()
  // 设置私钥
  jse.setPrivateKey(privateKey)
  // console.log('解密：'+jse.decrypt(pas))
  return jse.decrypt(pas)
}
export default {RSAencrypt, RSAdencrypt }



// WEBPACK FOOTER //
// ./src/components/utils/RSAencrypt.js